module.exports = __webpack_public_path__ + "img/138ne.8b9b71fb.svg";